export const namespaces = {
  translations: 'translations',
};

export const languages = {
  de: 'de',
  fr: 'fr',
  es: 'es',
  en: 'en',
  pt_BR: 'pt-BR',
};

export const defaultLang = languages.en;
